import { render, staticRenderFns } from "./header-creation-steps.vue?vue&type=template&id=537fa892&scoped=true"
import script from "./header-creation-steps.vue?vue&type=script&lang=js"
export * from "./header-creation-steps.vue?vue&type=script&lang=js"
import style0 from "./header-creation-steps.vue?vue&type=style&index=0&id=537fa892&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537fa892",
  null
  
)

export default component.exports